import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { CustomerService } from '../_services/index';
import { Webhook } from '../_models/index';



@Component({
    selector: 'configuration',
    templateUrl: './webhook.component.html',
    styleUrls: ['../../assets/css/customer-list-table.css']
})
export class WebhookComponent implements OnInit {
    webhookForm: FormGroup;
    public customer_public_id: string;
    statusresult: any;
    isalertVisiable = false;


    /**
 * constructor function is used to initialize 
 */
    constructor(

        private _fb: FormBuilder
        , private router: Router
        , private route: ActivatedRoute
        , private customerservice: CustomerService
    ) {
        this.isalertVisiable = false;
        this.InitialSetup();

    }
    InitialSetup() {




        this.webhookForm = this._fb.group({
            value: new FormControl(""),


        });
    }
    ngOnInit() {

        let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
        if (browserStorage1 == null) {
            let browserStorage = localStorage.getItem('companyId');
            if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
                this.router.navigate(['/home']);
            }
            else {
                this.customer_public_id = localStorage.getItem('companyId');
            }
        }
        else {
            this.customer_public_id = localStorage.getItem('subcompanyId');
        }

        this.GetCustomerWebhookDetails();
    }



    GetCustomerWebhookDetails() {
        this.customerservice.getWebhook(this.customer_public_id).subscribe(data => {

            setTimeout(() => {
                this.webhookForm = this._fb.group({
                    value: new FormControl(data.value)

                });
            }, 500)

        },
            error => {

                console.log('Failed while trying to the Customer Search All Result. ' + error);
            });
    }//end

    onsubmit(event, { value }: { value: Webhook }) {
        this.customerservice.createWebhook(this.customer_public_id, value)
            .subscribe((result) => {
                this.statusresult = "La información fue grabada correctamente !";
                this.isalertVisiable = true;
            },
                error => {
                   
                    this.isalertVisiable = false;
                    console.log('Failed while trying to update the Webhook Details.' + error);
                }
            );
    }
}